import { useTranslation } from '@wix/yoshi-flow-editor';
import React, { useState } from 'react';
import { IconTooltip, TooltipSkin } from 'wix-ui-tpa/cssVars';
import Info from 'wix-ui-icons-common/on-stage/Info';
import { TagName } from '../../../../utils/tagName.const';
import Text, { TextType } from '../../Text/Text';
import { PriceItemDataHooks } from '../PaymentSummary/PriceItem/dataHooks';
import { classes, st } from './Discount.st.css';

export interface DiscountRuleNameProps {
  name: string | undefined;
  align: 'start' | 'end';
  isCart: boolean | undefined;
  calculatedAtCheckout?: boolean;
  tooltipContent?: string;
}

export function DiscountRuleName({
  name,
  isCart,
  calculatedAtCheckout,
  align,
  tooltipContent,
}: DiscountRuleNameProps) {
  const { t } = useTranslation();
  const [isTooltipShown, setIsTooltipShown] = useState(false);

  return name || tooltipContent ? (
    <span className={st(classes.discountRuleNameRoot, { align })}>
      <span className={classes.discountNameWithTooltip}>
        {name && (
          <Text
            type={TextType.Secondary}
            className={classes.discountRuleName}
            data-hook={PriceItemDataHooks.DiscountRuleName}
          >
            {name}
          </Text>
        )}
        {tooltipContent && (
          <IconTooltip
            className={classes.discountTooltip}
            data-hook={PriceItemDataHooks.DiscountTooltip}
            icon={<Info aria-hidden="true" />}
            message={tooltipContent}
            tooltipSkin={TooltipSkin.Standard}
            showTooltip={isTooltipShown}
            onMouseEnter={() => setIsTooltipShown(true)}
            onFocus={() => setIsTooltipShown(true)}
            onBlur={() => setIsTooltipShown(false)}
            tooltipProps={{ onHide: () => setIsTooltipShown(false) }}
          />
        )}
      </span>
      {(isCart || calculatedAtCheckout) && (
        <Text
          type={TextType.Secondary}
          className={classes.appliedAtCheckout}
          data-hook={PriceItemDataHooks.CalculatedAtCheckout}
        >
          {t('app.bookings-form.bookings-details.calculated-at-checkout')}
        </Text>
      )}
    </span>
  ) : null;
}

export const PriceBeforeDiscount = ({ price, type }: { price: string | undefined; type: TextType }) => price ? (
  <Text
    type={type}
    tagName={TagName.Span}
    className={classes.priceBeforeDiscount}
    data-hook={PriceItemDataHooks.PriceBeforeDiscount}
  >
    {price}
  </Text>
) : null;
